<template>
    <div class="main">
        <c-panel>

            <div class="loading-instituicao">
                <img src="/public/img/loading-bar.gif" />
            </div>

        </c-panel>
    </div>
</template>
<script>

export default {
    mounted () {

        if(this.$store.state.user.tipo <= 1){

            this.$router.push('/admin/instituicao/edit/' + this.$store.state.config.instituicao.id);  
        
        }else{
        
            this.$router.push('/admin/instituicao');
        }
    },
}
</script>
<style>
    .loading-instituicao{
        height: 75vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
